<template>
  <div class="editor-row">
    <Multiselect
      v-model="sysfunctions"
      :max="-1"
      label="label"
      trackBy="id"
      valueByPath="id"
      :options="notificationsOptions"
      placeholder="Nastavení podle systémove funkcionality"
      @input="emit"
    >
    </Multiselect>
    <div>
      <Multiselect
        v-model="users"
        :max="-1"
        label="label"
        trackBy="id"
        valueByPath="id"
        :options="usersToSelect"
        placeholder="Ručně notifikovat systémové uživatele"
        @input="emit"
      >
      </Multiselect>
    </div>
    <div>
      <input v-model="emails"
             type="text"
             required="required"
             class="asd-input"
             placeholder="Seznam emailových adres pro odeslání notifikace"
             @input="emit"
      >
    </div>
  </div>
</template>

<script>
import { get, map } from 'lodash'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'

export default {
    name: 'NotificationsEditor',
    components: {
        Multiselect,
    },
    props: {
        value: {
            type: Object,
            required: true,
            default: () => {return {}},
        },
    },
    data: function() {
        return {
            sysfunctions: [],
            users: [],
            emails: '',
        }
    },
    computed: {
        notificationsOptions() {
            return [
                { id: 'assignee', label: 'Zpracovatele' },
                { id: 'allResources', label: 'Vsechny zdroje' },
                { id: 'author', label: 'Autor' },
            ]
        },
        usersToSelect() {
            return map(this.$store.getters.users, u => {
                return {
                    id: get(u, 'id'),
                    label: get(u, 'username'),
                }
            })
        },
    },
    watch: {
        value(n) {
            console.info(n)
            this.sysfunctions = get(n, 'sysfunctions', [])
            this.users = get(n, 'users', [])
            this.emails = get(n, 'emails', '')
        },
    },
    mounted() {
        this.sysfunctions = get(this.value, 'sysfunctions', [])
        this.users = get(this.value, 'users', [])
        this.emails = get(this.value, 'emails', '')
    },
    methods: {
        emit() {
            this.$emit('input', {
                sysfunctions: this.sysfunctions,
                users: this.users,
                emails: this.emails,
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.editor-row {
    display: flex;
    flex-direction: row;
    & > div {
        flex-grow: 1;
        width: 32%;
        &:not(:last-child) {
            margin-right: 5px;
        }
    }
}
</style>
